import { jsx as a } from "react/jsx-runtime";
import t from "@mui/material/Popover";
import s from "styled-components";
const d = {
  root: "popoverRoot",
  paper: "popoverPaper"
}, i = s(t).withConfig({
  displayName: "StyledPopover"
})([
  "& .popoverPaper{background-color:",
  ";padding:8px;margin-top:8px;box-shadow:0px 4px 20px 0px ",
  ";}"
], ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.primaryShadow), l = ({ children: o, classes: p, noShadow: r = !1, ...e }) => /* @__PURE__ */ a(i, {
  ...e,
  classes: {
    ...d,
    ...p
  },
  $noShadow: r,
  children: o
});
l.displayName = "Popover";
export {
  l as default
};
